import React, { useCallback } from 'react';
import styled from 'styled-components';

import { Body } from 'shared/fontStyles/StudioHeadings';

import StrikethroughLine from './StrikethroughLine';

import {
  VariantSelectionState,
  getCSSForState
} from './utils';

/**
 * Default Text Label Variant
 */
export default function DefaultVariant ({
  attributeType,
  attributeValue,
  state,
  updateSelectedForAttribute
}) {
  const onClick = useCallback(() => {
    state !== VariantSelectionState.DISABLED && updateSelectedForAttribute({ attributeType, attributeValue });
  }, [attributeType, attributeValue, state, updateSelectedForAttribute]);

  return (
    <Container
      data-testid={`AttributeComponent:${attributeType}:${attributeValue}`}
      onClick={onClick}
      stateCSS={getCSSForState(state)}
    >
      {attributeValue}
      <StrikethroughLine state={state} type={attributeType} />
    </Container>
  );
}

const Container = styled(Body)`
  position: relative;
  height: 48px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.stateCSS}
`;
